// ${env.REACT_APP_SERVER_API_URL}
import env from "environment";

const prefix = "/api/v1";

export default {
  cndServer: env.REACT_APP_SERVER_API_URL,
  customContract: {
    url: `${prefix}/contract-languages`,
    create: `${prefix}/contract-languages`,
    preview: `${prefix}/contract-languages/preview`,
    previewForListing: `${prefix}/contract-languages/preview-listing-contract`,
    previewContractByBid: (id) => `${env.REACT_APP_LISTINGS_API_URL}/bids/${id}/contract-preview`,
    previewInsuranceContract: `${prefix}/contract-languages/preview-insurance-contract`,
    deleteContract: (id) => `${prefix}/contract-languages/${id}`,
  },
  site: {
    createSite: `${prefix}/sites`,
    getAllSites: `${prefix}/sites`,
    getSite: (id) => `${prefix}/sites/${id}`,
    current: `${prefix}/sites/current`,
    checkDomain: `${prefix}/sites/check-domain`,
  },
  admin: {
    getListings: `${env.REACT_APP_LISTINGS_API_URL}/legacy/admin/listings`,
    getEstimates: `${env.REACT_APP_LISTINGS_API_URL}/legacy/admin/estimates`,
    getBiddings: `${env.REACT_APP_LISTINGS_API_URL}/legacy/admin/biddings`,
    getUsers: `${prefix}/admin/users`,
    setRole: (id) => `${prefix}/admin/users/${id}/set-role`,
    setRoleForUserById: (userId) => `${prefix}/admin/users/${userId}/set-role`,
    regenerateLeaseContract: (bidId) => `${env.REACT_APP_LISTINGS_API_URL}/bids/${bidId}/contract`,
  },
  agent: {
    getInvitation: (code) => `${prefix}/invitations/${code}`,
    acceptInvitation: (code) => `${prefix}/invitations/${code}/accept`,
    invitation: `${prefix}/partners/invite`,
    getAgents: `${prefix}/partners/users`,
    deleteTeamMember: (id) => `${prefix}/partners/users/${id}`,
  },
  organization: {
    new: `${prefix}/organization/new`,
    search: `${prefix}/organization/search`,
    getOrg: `${prefix}/organization/get`,
  },
  node: {
    create: `${prefix}/node/create`,
    update: `${prefix}/node/update`,
    find: `${prefix}/node/find`,
    findByIids: `${prefix}/node/find-by-iids`,
    detail: `${prefix}/node/detail`,
  },
  estimate: {
    create: `${env.REACT_APP_LISTINGS_API_URL}/estimates`,
    userEstimates: `${env.REACT_APP_LISTINGS_API_URL}/estimates`,
    getOverview: (id) => `${env.REACT_APP_LISTINGS_API_URL}/estimates/${id}/overview`,
    getValue: `${prefix}/estimate/value`,
    uploadFile: `${env.REACT_APP_PARCELS_API_SERVER_URL}/import-estimate`,
    confirmImport: `${env.REACT_APP_PARCELS_API_SERVER_URL}/confirm-import`,
  },
  fields: {
    getField: (id) => `${env.REACT_APP_LISTINGS_API_URL}/fields/${id}`,
  },
  leases: {
    getLeases: `${env.REACT_APP_LISTINGS_API_URL}/leases`,
    getByFarmId: (id) => `${env.REACT_APP_LISTINGS_API_URL}/leases/farm/${id}`,
  },
  user: {
    create: `${prefix}/user/create`,
    activate: `${prefix}/auth/register`,
    sendVerification: `${prefix}/auth/sendVerification`,
    login: `${prefix}/auth/login`,
    forgotPassword: `${prefix}/auth/forgot`,
    logout: `${prefix}/auth/logout`,
    profile: `${prefix}/users/me/profile`,
    changePassword: `${prefix}/auth/password`,
    update: (id) => `${prefix}/users/${id}`,
    getUser: (id) => `${prefix}/users/${id}`,
    uploadAvatar: `${prefix}/users/upload-avatar`,
    getMe: `${prefix}/auth/me`,
    refreshToken: `${prefix}/auth/refresh`,
    verify: `${prefix}/auth/verify`,
    checkEmail: `${prefix}/auth/check-email`,
    createCredentials: `${prefix}/auth/create-credentials`,
  },
  audit: {
    getUserActivityData: `${env.REACT_APP_LISTINGS_API_URL}/audit/user-activity`,
  },
  administrative: {
    getState: `${prefix}/administrative`,
    getCities: (id) => `${prefix}/administrative/${id}/cities`,
  },
  farm: {
    get: (id) => `${env.REACT_APP_LISTINGS_API_URL}/farms/${id}`,
    delete: (id) => `${env.REACT_APP_LISTINGS_API_URL}/farms/${id}`,
    getAll: `${env.REACT_APP_LISTINGS_API_URL}/farms`,
    update: (id) => `${env.REACT_APP_LISTINGS_API_URL}/farms/${id}`,
    create: `${env.REACT_APP_LISTINGS_API_URL}/farms`,
    overview: (id) => `${env.REACT_APP_LISTINGS_API_URL}/farms/${id}/overview`,
    getFields: (id) => `${env.REACT_APP_LISTINGS_API_URL}/farms/${id}/fields`,
    getLeases: (id) => `${env.REACT_APP_LISTINGS_API_URL}/farms/${id}/leases`,
  },
  listing: {
    create: `${env.REACT_APP_LISTINGS_API_URL}/listings`,
    update: (id) => `${env.REACT_APP_LISTINGS_API_URL}/listings/${id}`,
    updateInsurance: (id) => `${env.REACT_APP_LISTINGS_API_URL}/listings/${id}/insurance`,
    getPaymentsQuote: `${env.REACT_APP_LISTINGS_API_URL}/listings/payments-schedule`,
    getRecentListings: `${env.REACT_APP_LISTINGS_API_URL}/legacy/listings/recent`,
    searchListings: `${env.REACT_APP_LISTINGS_API_URL}/legacy/listings`,
    getUserListings: `${env.REACT_APP_LISTINGS_API_URL}/legacy/listings/my-listings`,
    detail: (id) => `${prefix}/listings/${id}`,
    details: (id) => `${env.REACT_APP_LISTINGS_API_URL}/legacy/listings/${id}`,
    changeVisibility: (id) => `${env.REACT_APP_LISTINGS_API_URL}/listings/${id}/change-visibility`,
    publish: (id) => `${env.REACT_APP_LISTINGS_API_URL}/listings/${id}/publish`,
    delete: (id) => `${env.REACT_APP_LISTINGS_API_URL}/listings/${id}/delete`,
    uploadFile: (id) => `${env.REACT_APP_LISTINGS_API_URL}/listings/${id}/upload-file`,
    deleteFile: (listingId, fileId) => `${env.REACT_APP_LISTINGS_API_URL}/listings/${listingId}/files/${fileId}`,
    estimate: `${prefix}/listings/estimate`,
    createFromEstimate: (id) => `${env.REACT_APP_LISTINGS_API_URL}/listings/estimate/${id}`,
    sortFile: (id) => `${env.REACT_APP_LISTINGS_API_URL}/listings/${id}/sort-files`,
    setInsuranceFee: (id) => `${env.REACT_APP_LISTINGS_API_URL}/listings/${id}/insurance-fee`,
    confirm: (id) => `${env.REACT_APP_LISTINGS_API_URL}/legacy/admin/listings/${id}/confirm`,
    soldListing: (id) => `${env.REACT_APP_LISTINGS_API_URL}/listings/${id}/sold`,
    getGroundOptions: `${env.REACT_APP_LISTINGS_API_URL}/listings/ground-options`,
    setMaxBid: (id) => `${env.REACT_APP_LISTINGS_API_URL}/listings/${id}/max-bid`,
  },
  location: {
    loadState: `${prefix}/administrative`,
    getCity: (id) => `${prefix}/administrative/${id}/cities`,
  },
  parcel: {
    loadDataByParcelId: (parcelId, searchStateOrCountry) => `https://reportallusa.com/api/parcels.php?client=${env.REACT_APP_PARCEL_KEY_REPORT_ALL}&v=4&parcel_id=${parcelId}&region=${searchStateOrCountry}`,
    loadSoilAreas: `${env.REACT_APP_SOIL_API_SERVER_URL}/api/soilareas`,
    clupoly: `${env.REACT_APP_SOIL_API_SERVER_URL}/api/clupoly`,
    soilFeatures: `${env.REACT_APP_SOIL_API_SERVER_URL}/api/soil-features`,
  },
  soilMap: {
    loadUrl: () => `${env.REACT_APP_PARCELS_API_SERVER_URL}/load-url`,
  },
  tenant: {
    settings: `${prefix}/settings`,
  },
  addresses: {
    findCities: `${prefix}/addresses/cities`,
    findStates: `${prefix}/addresses/states`,
    search: `${prefix}/addresses/search`,
    autocomplete: (search, type) => `${prefix}/addresses/autocomplete?search=${search}&type=${type}`,
  },
  regionBoundary: (address) => `https://nominatim.openstreetmap.org/search.php?q=${address}&polygon_geojson=1&format=json`,
  notification: {
    getNotifications: `${prefix}/notifications`,
    deleteNotification: (id) => `${prefix}/notifications/${id}`,
    getNotificationSettings: `${prefix}/notification-settings`,
    createNotificationSetting: `${prefix}/notification-settings`,
    deleteNotificationSetting: (id) => `${prefix}/notification-settings/${id}`,
  },
  payment: {
    getPaymentMethods: `${prefix}/payment-methods`,
    createPaymentMethod: `${prefix}/payment-methods`,
    deletePaymentMethod: (id) => `${prefix}/payment-methods/${id}`,
    updatePaymentMethod: (id) => `${prefix}/payment-methods/${id}`,
    setDefault: (id) => `${prefix}/payment-methods/${id}/default`,
    getTransaction: `${prefix}/transactions/my-transactions`,
    verifyBankAccount: (id) => `${prefix}/payment-methods/${id}/verify-bank-account`,
    createOnboardLink: `${prefix}/payments/join-link`,
    getPlaidLinkToken: () => `${prefix}/payments/stripe/link-token`,
    bindAccountBank: () => `${prefix}/payment-methods/bind-plaid-account`,
  },
  watch: {
    watchItems: `${env.REACT_APP_LISTINGS_API_URL}/listings/watch-list`,
    addWatchListing: (id) => `${env.REACT_APP_LISTINGS_API_URL}/listings/${id}/watch-list`,
    deleteWatchListing: (id) => `${env.REACT_APP_LISTINGS_API_URL}/listings/${id}/watch-list`,
  },
  biddings: {
    biddings: `${prefix}/biddings`,
    createBidding: (id) => `${env.REACT_APP_LISTINGS_API_URL}/listings/${id}/bids`,
    getDraftBid: (id) => `${env.REACT_APP_LISTINGS_API_URL}/listings/${id}/bids/draft`,
    myContract: `${env.REACT_APP_LISTINGS_API_URL}/bids/awarded`,
    myBiddings: `${env.REACT_APP_LISTINGS_API_URL}/bids`,
    getBiddingDetail: (id) => `${env.REACT_APP_LISTINGS_API_URL}/bids/${id}`,
    getBiddingsOfListing: (id) => `${env.REACT_APP_LISTINGS_API_URL}/listings/${id}/bids`,
    reject: (id) => `${env.REACT_APP_LISTINGS_API_URL}/bids/${id}/reject`,
    sign: (id) => `${env.REACT_APP_LISTINGS_API_URL}/bids/${id}/sign`,
    withdraw: (id) => `${env.REACT_APP_LISTINGS_API_URL}/bids/${id}/withdraw`,
    payByCheck: (id) => `${env.REACT_APP_LISTINGS_API_URL}/legacy/admin/biddings/${id}/pay-check`,
    signInsurance: (id) => `${env.REACT_APP_LISTINGS_API_URL}/bids/${id}/sign-insurance`,
    agreements: `${env.REACT_APP_LISTINGS_API_URL}/bids/agreements`,
    inviteSigners: (id) => `${env.REACT_APP_LISTINGS_API_URL}/bids/${id}/signers`,
    deleteSigner: (id, signerId) => `${env.REACT_APP_LISTINGS_API_URL}/bids/${id}/signers/${signerId}`,
    tokenAgreements: (token) => `${env.REACT_APP_LISTINGS_API_URL}/bids/${token}/agreements`,
    aceptBid: (id) => `${env.REACT_APP_LISTINGS_API_URL}/bids/${id}/accept`,
  },
  partner: {
    registerPartner: `${prefix}/partnerSignupRequests`,
    users: `${prefix}/partners/users`,
    setCommission: (id) => `${prefix}/partners/users/${id}/set-commission`,
  },
  question: {
    getListingQuestions: (id) => `${env.REACT_APP_LISTINGS_API_URL}/listings/${id}/listing-messages`,
    createQuestion: `${env.REACT_APP_LISTINGS_API_URL}/listing-messages`,
    createAnswer: (id) => `${env.REACT_APP_LISTINGS_API_URL}/listing-messages/${id}/answer`,
  },
  contactUs: `${prefix}/contact-messages`,
  getAllCashrentstimatePdfs: `${env.REACT_APP_SERVER_API_URL}${prefix}/pdf`,
  leads: {
    create: `${env.REACT_APP_LISTINGS_API_URL}/lead-from-contact`,
  },
  bidders: {
    registerToBid: `${env.REACT_APP_LISTINGS_API_URL}/bidders/register`,
    updatePaymentMethod: (id) => `${env.REACT_APP_LISTINGS_API_URL}/bidders/${id}`,
    getBidder: (id) => `${env.REACT_APP_LISTINGS_API_URL}/bidders/${id}`,
  },
};
